import styles from "./OTPInput.module.css";

function OTPInput({
    otp,
    setOtp,
    isVerifying,
    isVerified,
    timer,
    formatTimer,
    onResend,
    hasError,
    onErrorClear,
    showResendInHeader = true
}) {
    const handleOTPChange = (index, value, e) => {
        const numValue = value.replace(/\D/g, '');
        if (numValue) {
            const newOtp = otp.split('');
            newOtp[index] = numValue;
            setOtp(newOtp.join(''));

            // Clear error when user starts typing
            if (hasError && onErrorClear) {
                onErrorClear();
            }

            // Auto-focus next input
            if (index < 5) {
                const nextInput = e.target.parentElement.children[index + 1];
                if (nextInput) nextInput.focus();
            }
        }
    };

    const handleKeyDown = (index, e) => {
        if (e.key === 'Backspace' && !otp[index] && index > 0) {
            const prevInput = e.target.parentElement.children[index - 1];
            if (prevInput) prevInput.focus();
        }
    };

    return (
        <div className={styles["otp-container"]}>
            <div className={styles["otp-header"]}>
                <span className={styles["otp-label"]}>Enter your 6-digit OTP here</span>
                {showResendInHeader && (
                    <span className={styles["resend-otp-container"]}>
                        {timer > 0 ? (
                            <span className={styles["resend-timer"]}>{formatTimer(timer)}</span>
                        ) : (
                            <button
                                type="button"
                                className={styles["resend-otp-button"]}
                                onClick={onResend}
                            >
                                Resend OTP
                            </button>
                        )}
                    </span>
                )}
                {!showResendInHeader && timer > 0 && (
                    <span className={styles["resend-timer"]}>{formatTimer(timer)}</span>
                )}
            </div>



            <div className={styles["otp-input-wrapper"]}>
                {[0, 1, 2, 3, 4, 5].map((index) => (
                    <input
                        key={index}
                        type="text"
                        maxLength={1}
                        className={`${styles["otp-input"]} ${isVerifying ? styles["otp-input-loading"] : ""} ${hasError ? styles["otp-input-error"] : ""}`}
                        value={otp[index] || ""}
                        onChange={(e) => handleOTPChange(index, e.target.value, e)}
                        onKeyDown={(e) => handleKeyDown(index, e)}
                        disabled={isVerifying || isVerified}
                        autoFocus={index === 0}
                    />
                ))}
            </div>

        </div>
    );
}

export default OTPInput;

